export type AvailablePageTemplates = {
  documentType: string;
};

export const PageTemplates: AvailablePageTemplates[] = [
  {
    documentType: 'pageHome',
  },
  {
    documentType: 'pageService',
  },
  {
    documentType: 'pagePrices',
  },
  {
    documentType: 'pageLegal',
  },
];
